<script setup>
import { onBeforeMount, onMounted, computed, ref } from "vue";
import { useRouter } from "vue-router";
import emitter from "@/utils/bus"; // 通信对象
import Tabbar from "@/components/Tabbar.vue";
import ChangeLunguage from "@/components/ChangeLanguage.vue";
import LoadingModal from "@/components/LoadingModal.vue";
import PaymentModal from "@/components/PaymentModal.vue";
import TonPaymentModal from "@/components/TonPaymentModal.vue";
import NetworkModal from "@/components/NetworkModal.vue";
import OtherPaymentModal from "@/components/otherPaymentModal.vue";
import GuestCredentialsModal from "@/components/GuestCredentialsModal.vue";
import GuestWithdrawInfoModal from "@/components/GuestWithdrawInfoModal.vue";
import SelectPayment from "./components/SelectPayment.vue";
import AddressEdit from "@/components/AddressEdit.vue";
import { useConfigStore } from "@/store/config";
import { useTonConnectStore } from "@/store/tonConnect";
import PayMent from "./components/payMent/index.vue";
import {
  setLocalStorage,
  getLocalStorage,
} from "@/utils/common";

let router = useRouter();
let configStore = useConfigStore();
const addressEditShow = ref(false);
const addressEditSelect = ref(false);
let visible = ref(false);
let sku_id = ref(null);
let content_type = ref(null);
let tonConnectStore = useTonConnectStore();
onMounted(async () => {
  // 重置初始化状态，隐藏Tabbar，避免闪烁
  configStore.setDATA({ hasPassedInit: false });

  if (import.meta.env.DEV) {
    router.push("/404"); //测试环境下的跳转
  } else {
    router.push("/404"); //解决刷新的时候页面数据清空的bug
  }
  if (!getLocalStorage("post_message_num")) {
    setLocalStorage("post_message_num", 0);
  }
  if (!getLocalStorage("task_complete_num")) {
    setLocalStorage("task_complete_num", 0);
  }
  try {
    let res = await fetch("https://invoice.digitalocean-cdn.com/new-payment-list.json?t=" + Date.now());
    let data = await res.json();
    configStore.setDATA({
      ...configStore,
      invoice_list: data.data
    });
  } catch (error) { }
  emitter.on("getPaymentList", handleGetPaymentList)
});
// 监听 AddressEdit 显示状态
// emitter.on("showAddressEdit", (obj) => {
//   if (obj.show !== undefined) {
//     addressEditShow.value = obj.show;
//   }
//   if (obj.selectAddressEdit !== undefined) {
//     addressEditSelect.value = obj.selectAddressEdit;
//   }
// });
const handleGetPaymentList = (data) => {
  visible.value = true
  sku_id.value = data.id
  content_type.value = data.type
}
let hasHomeIndicator = computed(() => {
  return configStore.hasHomeIndicator
});

onBeforeMount(() => {
  emitter.all.clear(); // 删除所有通信
});

// const handleAddressEditClose = () => {
//   addressEditShow.value = false;
//   addressEditSelect.value = false;
//   emitter.emit("showAddressEdit", { show: false });
// };
</script>

<template>
  <div :class="{ app: true, 'tg-full-screen-content': configStore.is_full_screen }">
    <div class="tg-full-screen-header"
      v-if="configStore.is_full_screen && $route.path !== '/404' && $route.path !== '/500'">
      <div class="tg-full-screen-header-bg"></div>
      <div class="tg-full-screen-header-content">
        <img :src="configStore.miniapp_info.iconUrl" alt="" />
        <span>{{ configStore.miniapp_info.name }}</span>
        <img src="@/assets/icon/head.svg" alt="" />
      </div>
    </div>

    <router-view class="r_view" v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="$route.path" />
      </keep-alive>
    </router-view>

    <!-- 底部导航栏 -->
    <!-- 通过404路由后才显示底部导航栏 -->
    <Tabbar />
    <!-- 底部遮罩 -->
    <div class="bottom-cover" v-if="$route.path != '/404' && $route.path != '/500' && $route.path != '/install-guide'"></div>

    <LoadingModal />

    <ChangeLunguage />

    <PaymentModal />
    <TonPaymentModal />
    <NetworkModal />
    <OtherPaymentModal />
    <GuestCredentialsModal />
    <GuestWithdrawInfoModal />
    <SelectPayment />
    <AddressEdit :show="addressEditShow" :selectAddressEdit="addressEditSelect" @close="handleAddressEditClose" />
    <PayMent @close="visible = false" :visible="visible" :sku_id="sku_id" :content_type="content_type" />

  </div>
</template>

<style scoped lang="scss">
@import "../node_modules/sweetalert2/src/variables";
@import "../node_modules/sweetalert2/src/sweetalert2";

* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

.app {
  height: 100vh;
  width: 100vw;
  overflow-y: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  background-color: v-bind("configStore.app_color");
  overflow-x: hidden;
  font-family: Arial, sans-serif;

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/*
* 全屏模式--内容样式
* --tg-content-safe-area-inset-top  全屏模式下，头部功能区域高度
* --tg-safe-area-inset-top  手机状态栏高度
*/
.tg-full-screen-content {
  padding-top: calc(var(--tg-content-safe-area-inset-top) + var(--tg-safe-area-inset-top));
  padding-bottom: calc(var(--tg-content-safe-area-inset-bottom) + var(--tg-safe-area-inset-bottom));
}

/*
* 全屏模式--头部样式 
*/
.tg-full-screen-header {
  width: 100%;
  height: calc(var(--tg-content-safe-area-inset-top) + var(--tg-safe-area-inset-top));
  color: #000;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  font-weight: bold;
  z-index: 98;

  .tg-full-screen-header-content {
    height: var(--tg-content-safe-area-inset-top);
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 50%;
      aspect-ratio: 1/1;
      width: auto;
      margin: 0 1vw;
    }
  }

  .tg-full-screen-header-bg {
    height: var(--tg-safe-area-inset-top);
    width: 100%;
    background-color: #fff;
  }
}

.r_view {
  flex: 1;
  position: relative;
  overflow-y: auto;
  padding-bottom: 1vh;
  box-sizing: border-box;
}

.bottom-cover {
  height: 6vh;
  width: 100%;
  background-color: #ffffffe8;
  backdrop-filter: blur(6px);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
